/* ==========================================================================
   idam-search-popup.js

   Full-width search popup (Trending + Best Sellers + product cards + ADD TO CART),
   modelled on the bellavitaorganic.com custom search popup. Opens when the
   store's search input/icon is focused/clicked. Content is driven entirely by
   the search backend's /api/v1/search/autocomplete endpoint:
     - empty query  -> trending terms + best-seller products
     - with a query -> categories + matching products
   Markup uses the same class names as idam-search-popup.css so it looks identical.

   Config comes from data-* attributes on #custom-search-first-view.
   ========================================================================== */
(function () {
  'use strict';

  var DEBOUNCE_MS = 250;
  var root, cfg = {};
  var els = {};
  var isOpen = false;
  var debounceTimer = null;
  var activeReq = 0;
  var abortCtrl = null;
  var cache = {};
  var scrollY = 0;

  /* ------------------------------------------------------------------ utils */
  function escapeHtml(v) {
    if (v == null) return '';
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(amount) {
    if (amount == null || amount === '' || isNaN(amount)) return '';
    var n = Number(amount);
    var hasDec = Math.round(n) !== n;
    var num = n.toLocaleString(undefined, {
      minimumFractionDigits: hasDec ? 2 : 0,
      maximumFractionDigits: 2
    });
    return cfg.symbol + num;
  }

  function getSessionId() {
    try {
      var k = 'bv_search_session_id';
      var id = sessionStorage.getItem(k);
      if (!id) {
        id = (typeof crypto !== 'undefined' && crypto.randomUUID)
          ? crypto.randomUUID()
          : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
              var r = (Math.random() * 16) | 0;
              return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
            });
        sessionStorage.setItem(k, id);
      }
      return id;
    } catch (e) { return ''; }
  }

  function apiFetch(path, signal) {
    return fetch(cfg.baseUrl + path, {
      headers: { 'X-Shop-Domain': cfg.shopDomain, 'X-Session-Id': getSessionId(), 'Accept': 'application/json' },
      signal: signal
    }).then(function (r) { return r.json(); });
  }

  /* --------------------------------------------------------------- rendering */
  function renderTrending(terms, heading) {
    if (!els.trendingList) return;
    if (!terms || !terms.length) { els.trending.style.display = 'none'; return; }
    if (els.trendingTitle) els.trendingTitle.textContent = heading || 'Trending Searches';
    var html = terms.map(function (t) {
      var term = (typeof t === 'string') ? t : (t.term || t.value || t.title || '');
      // Skip internal/junk terms that occasionally leak into the API's trending list.
      if (!term || /pending|review|^hidden$|draft|skip-collection/i.test(term)) return '';
      return '<li class="trending-keyword-item"><a href="' + cfg.resultsPath + '?q=' +
        encodeURIComponent(term) + '">' + escapeHtml(term) + '</a></li>';
    }).join('');
    if (!html) { els.trending.style.display = 'none'; return; }
    els.trendingList.innerHTML = html;
    els.trending.style.display = '';
  }

  function renderCategories(cats) {
    if (!els.catList || !els.categories) return;
    var html = (cats || []).map(function (c) {
      var term = (typeof c === 'string') ? c : (c.value || c.title || c.term || '');
      if (!term) return '';
      return '<li class="trending-keyword-item"><a href="' + cfg.resultsPath + '?q=' +
        encodeURIComponent(term) + '">' + escapeHtml(term) + '</a></li>';
    }).join('');
    if (!html) { els.categories.hidden = true; els.categories.style.display = 'none'; return; }
    els.catList.innerHTML = html;
    els.categories.hidden = false;
    els.categories.style.display = '';
  }

  function productCard(p) {
    var imgs = p.images || [];
    var imgUrl = imgs.length ? (imgs[0].src || imgs[0].url) : (p.image || '');
    var title = p.title || '';
    var handle = p.handle || '';
    var v = (p.variants && p.variants[0]) || {};
    var price = (v.price != null) ? v.price : (p.minPrice || 0);
    var compareAt = v.compareAtPrice || 0;
    if (compareAt <= price) compareAt = 0;
    var discount = (compareAt && compareAt > price) ? Math.round(((compareAt - price) / compareAt) * 100) : 0;
    var gid = v.shopifyId || '';
    var variantId = gid.replace(/.*\//, '');
    var pdp = '/products/' + encodeURIComponent(handle);
    var sep = imgUrl && imgUrl.indexOf('?') === -1 ? '?' : '&';
    var imgTag = imgUrl
      ? '<img src="' + escapeHtml(imgUrl) + sep + 'width=400" alt="' + escapeHtml(title) + '" loading="lazy" width="400" height="400">'
      : '';

    var h = '<div class="top-products-card product-card">';
    h += '<div class="top-product-img-wrap"><a href="' + pdp + '">' + imgTag + '</a>';
    if (discount > 0) h += '<div class="top-product-discount">' + discount + '% OFF</div>';
    h += '</div>';
    h += '<h3><a href="' + pdp + '">' + escapeHtml(title.length > 18 ? title.substring(0, 18) + '...' : title) + '</a></h3>';
    h += '<p><span>' + money(price) + '</span>';
    if (compareAt) h += ' <del>' + money(compareAt) + '</del>';
    h += '</p>';
    if (variantId && v.availableForSale !== false) {
      h += '<button type="button" class="search-atc" data-atc-variant="' + variantId + '">ADD TO CART</button>';
    } else {
      h += '<a href="' + pdp + '" class="search-atc">' + (v.availableForSale === false ? 'SOLD OUT' : 'ADD TO CART') + '</a>';
    }
    h += '</div>';
    return h;
  }

  var HIDDEN_TAGS = ['product-hide', 'hidden', 'skip-collection', 'upsell_product'];
  function visible(p) {
    var tags = p.tags || [];
    if (typeof tags === 'string') tags = tags.split(',');
    for (var i = 0; i < tags.length; i++) {
      if (HIDDEN_TAGS.indexOf((tags[i] + '').trim().toLowerCase()) !== -1) return false;
    }
    return true;
  }

  // Sold out when no variant is available for sale.
  function isSoldOut(p) {
    var vs = p.variants || [];
    if (!vs.length) return (p.available === false) || (p.totalInventory === 0);
    for (var i = 0; i < vs.length; i++) { if (vs[i].availableForSale) return false; }
    return true;
  }

  // Only show in-stock, non-hidden products (sold-out ones would show a
  // "Notify me when available" overlay from the back-in-stock app).
  function purchasable(p) { return visible(p) && !isSoldOut(p); }

  function renderProducts(items, heading, query) {
    if (!els.productsGrid) return;
    items = (items || []).filter(purchasable);
    if (!items.length) {
      els.products.style.display = 'none';
      return;
    }
    if (els.productsTitle) {
      // "See all" -> search results for a query, or the best-sellers collection when empty.
      var seeHref = query ? (cfg.resultsPath + '?q=' + encodeURIComponent(query)) : cfg.bestsellersUrl;
      els.productsTitle.innerHTML =
        '<span class="cs-heading-text">' + escapeHtml(heading) + '</span>' +
        '<a class="cs-see-all" href="' + seeHref + '">See all &rarr;</a>';
    }
    els.productsGrid.innerHTML = items.map(productCard).join('');
    els.products.style.display = '';
  }

  function shimmer() {
    if (!els.productsGrid) return;
    var h = '';
    for (var i = 0; i < 6; i++) {
      h += '<div class="search-shimmer-card"><div class="search-shimmer-img"></div>' +
        '<div class="search-shimmer-line medium"></div><div class="search-shimmer-line short"></div>' +
        '<div class="search-shimmer-btn"></div></div>';
    }
    els.productsGrid.innerHTML = h;
    els.products.style.display = '';
    if (els.productsTitle) els.productsTitle.textContent = '';
  }

  /* ----------------------------------------------------------------- queries */
  function load(query) {
    query = (query || '').trim();
    var key = query.toLowerCase();
    if (cache[key]) { paint(cache[key], query); return; }

    if (query) shimmer();
    var reqId = ++activeReq;
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;

    var qs = '?productLimit=' + cfg.productLimit + '&categoryLimit=6&trendingLimit=' + cfg.trendingLimit;
    if (query) qs += '&q=' + encodeURIComponent(query);

    apiFetch('/api/v1/search/autocomplete' + qs, abortCtrl ? abortCtrl.signal : undefined)
      .then(function (body) {
        if (reqId !== activeReq) return;
        var data = (body && body.data) ? body.data : {};
        cache[key] = data;
        paint(data, query);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (reqId !== activeReq) return;
        paint({ trending: [], products: [], categories: [] }, query);
      });
  }

  function paint(data, query) {
    // Categories (typing only), Trending searches, then products. Each section
    // hides itself when its data is empty.
    renderCategories(data.categories || []);
    renderTrending((data.trending || []).map(function (t) { return t.term || t.value || t; }), 'Trending Searches');
    renderProducts(data.products || [], query ? 'Products' : 'Best Sellers', query);

    if (query && els.productsGrid && !(data.products || []).filter(purchasable).length) {
      els.products.style.display = '';
      if (els.productsTitle) els.productsTitle.textContent = '';
      els.productsGrid.innerHTML = '<p class="custom-search-suggest-message">No matches for &ldquo;' +
        escapeHtml(query) + '&rdquo;. <a href="' + cfg.resultsPath + '?q=' + encodeURIComponent(query) + '">Search anyway &rarr;</a></p>';
    }
  }

  /* ------------------------------------------------------------- open / close */
  function open() {
    if (isOpen) return;
    isOpen = true;
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.style.setProperty('--scroll-y', '-' + scrollY + 'px');
    document.documentElement.classList.add('custom-search-open');
    document.body.classList.add('custom-search-open');
    root.classList.add('is-open');
    // On mobile the popup has its own visible input; on desktop the user keeps
    // typing in the store's header field, so only steal focus when visible.
    if (els.input) {
      els.input.value = '';
      setTimeout(function () { if (els.input.offsetParent !== null) els.input.focus(); }, 30);
    }
    if (els.clear) els.clear.classList.remove('is-visible');
    load('');
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    document.documentElement.classList.remove('custom-search-open');
    document.body.classList.remove('custom-search-open');
    root.classList.remove('is-open');
    // restore scroll position (mobile fixed-body lock)
    document.documentElement.style.removeProperty('--scroll-y');
    if (window.scrollY === 0 && scrollY) window.scrollTo(0, scrollY);
  }

  function submit(term) {
    term = (term || '').trim();
    if (!term) return;
    var sep = cfg.resultsPath.indexOf('?') === -1 ? '?' : '&';
    window.location.href = cfg.resultsPath + sep + 'q=' + encodeURIComponent(term);
  }

  /* ------------------------------------------------------------- add to cart */
  function addToCart(variantId, btn) {
    if (!variantId) return;
    btn.classList.add('is-loading');

    // Use the theme's own cart mechanism (<mini-cart>): request the cart sections
    // in the add call, then hand the response to renderContents(), which refreshes
    // the cart-icon-bubble (+ mobile) and mini-cart, and opens the cart drawer.
    var miniCart = document.querySelector('mini-cart');
    var sections = (miniCart && typeof miniCart.getSectionsToRender === 'function')
      ? miniCart.getSectionsToRender().map(function (s) { return s.id; })
      : ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); })
      .then(function (parsedState) {
        btn.classList.remove('is-loading');
        // Add failed (e.g. sold out / not enough stock) — Shopify returns a status.
        if (!parsedState || parsedState.status) return;
        // Close the search popup so the cart drawer is visible & scroll-lock is clean.
        close();
        if (miniCart && typeof miniCart.renderContents === 'function') {
          miniCart.renderContents(parsedState); // updates bubbles + opens drawer
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  /* ---------------------------------------------------------------- bindings */
  // Selectors for the store's search entry points (Wizzy/SearchTap/native Dawn).
  var INPUT_SEL = '.wizzy-search-input, .custom-search-header-input, .search__input, input[type="search"][name="q"], [data-cs-input]';
  var ICON_SEL = '.st-searchicon, .st-search-bar, .header__icon--search, summary.header__icon--search, .icon-container, [data-cs-open]';

  function matches(el, sel) { return el && el.closest && el.closest(sel); }

  function initTriggers() {
    // Open when the store's search field gets focus/click.
    document.addEventListener('focusin', function (e) {
      if (isOpen) return;
      var t = matches(e.target, INPUT_SEL);
      if (t && !root.contains(e.target)) open();
    });
    document.addEventListener('click', function (e) {
      // search icon / bar -> open (and suppress any app popup)
      var icon = matches(e.target, ICON_SEL);
      if (icon && !root.contains(e.target) && !isOpen) {
        e.preventDefault();
        e.stopPropagation();
        open();
        return;
      }
      // click outside the popup -> close
      if (isOpen && !root.contains(e.target) && !matches(e.target, INPUT_SEL) && !matches(e.target, ICON_SEL)) {
        close();
      }
    }, true);

    // Mirror typing from ANY store search input (desktop types in the header
    // field; mobile types in the popup's own field) into the results.
    document.addEventListener('input', function (e) {
      if (!isOpen) return;
      if (!matches(e.target, INPUT_SEL)) return;
      var v = e.target.value;
      if (els.input && e.target !== els.input) els.input.value = v;
      if (els.clear) els.clear.classList.toggle('is-visible', v.length > 0);
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { load(v); }, DEBOUNCE_MS);
    });
  }

  function initPopupEvents() {
    // Enter/Escape from the popup input (typing itself is handled by the
    // document-level 'input' delegation so the store's own field works too).
    if (els.input) {
      els.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit(els.input.value); }
        else if (e.key === 'Escape') { close(); }
      });
    }
    if (els.clear) els.clear.addEventListener('click', function () {
      els.input.value = ''; els.clear.classList.remove('is-visible'); load(''); els.input.focus();
    });
    [els.close, els.back].forEach(function (b) { if (b) b.addEventListener('click', close); });

    // event delegation inside the popup: ATC buttons + card clicks
    root.addEventListener('click', function (e) {
      var atc = e.target.closest('[data-atc-variant]');
      if (atc) { e.preventDefault(); addToCart(atc.getAttribute('data-atc-variant'), atc); }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
  }

  /* --------------------------------------------------------------------- boot */
  function boot() {
    root = document.getElementById('custom-search-first-view');
    if (!root || root.__csBooted) return;
    root.__csBooted = true;

    cfg = {
      baseUrl: (root.getAttribute('data-backend-base-url') || '').replace(/\/$/, ''),
      shopDomain: root.getAttribute('data-shop-domain') || '',
      resultsPath: root.getAttribute('data-results-path') || '/search',
      symbol: root.getAttribute('data-currency-symbol') || '₹',
      productLimit: parseInt(root.getAttribute('data-product-limit'), 10) || 8,
      trendingLimit: parseInt(root.getAttribute('data-trending-limit'), 10) || 6,
      bestsellersUrl: root.getAttribute('data-bestsellers-url') || '/search'
    };
    if (!cfg.baseUrl) { console.warn('[idam-search-popup] backend base url missing'); return; }

    els = {
      input: root.querySelector('[data-cs-input]'),
      clear: root.querySelector('[data-cs-clear]'),
      close: root.querySelector('[data-cs-close]'),
      back: root.querySelector('[data-cs-back]'),
      trending: root.querySelector('[data-cs-trending]'),
      trendingTitle: root.querySelector('[data-cs-trending-title]'),
      trendingList: root.querySelector('[data-cs-trending-list]'),
      categories: root.querySelector('[data-cs-categories]'),
      catList: root.querySelector('[data-cs-cat-list]'),
      products: root.querySelector('[data-cs-products]'),
      productsTitle: root.querySelector('[data-cs-products-title]'),
      productsGrid: root.querySelector('[data-cs-products-grid]')
    };

    initTriggers();
    initPopupEvents();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
